import axios from "axios";
import API from "../../utils/APIUtils"

export const getConnectedContact = async () => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/usercontact/connections`, {
            headers: {
                "Content-Type": 'application/json'
            }
        });

        return response.data;

    } catch (error) {

        console.log("API Error", error);
        if (error.response.data) {
            return error.response.data;
        } else if (error.request) {
            return { message: 'NO resoinse recived from the server' }

        } else {
            return { message: error.message }
        }
    }
};

export const getUserFolderDetails = async () => {

    try {

        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/usercontact/userfolderdetails`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error", error);

        if (error.response.message) {
            return error.response.message;
        } else if (error.request) {
            return { message: 'a server is not reponding' }
        } else {
            return { message: error.message }
        }
    }
}

export const getAllFolders = async () => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/all-folders`);

        return response?.data;
    } catch (error) {
        console.log("getAllFolders API Error:", error);
        if (error.response?.data?.message) {
            return error.response?.data?.message;
        } else {
            return { message: error.message }
        }
    }
}

export const getSelectedFolderDetails = async (params) => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/folder/${params.id}`, {
            params: {
                page: params?.page || 0
            }
        });

        return response?.data;
    } catch (error) {
        console.log("getSelectedFolderDetails API Error:", error);
        if (error.response?.data?.message) {
            return error.response?.data?.message;
        } else {
            return { message: error.message }
        }
    }
}

export const getContactGroup = async () => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/usercontact/groups`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.log("API error", error);
        if (error.response.message) {
            return error.request.message;
        } else if (error.request) {
            return { message: 'server is not responding ' }
        } else {
            return { message: error.message }
        }
    }
}

export const getUserDetailedView = async ({ id }) => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/usercontact/userdetails`, {
            headers: {
                "Content-Type": "application/json",
                referenceId: id,
            }
        });
        return response.data;
    } catch (error) {
        console.log("API error", error);
        if (error.response.message) {
            return error.request.message;
        } else if (error.request) {
            return { message: 'server is not responding ' }
        } else {
            return { message: error.message }
        }
    }
}


export const postCreateContactGroup = async (formData) => {

    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };
    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/groups`, formData, {
            headers: {
                Authorization: authHeader,
                "Content-Type": "multipart/data-form",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })


        return response;
    } catch (error) {
        console.log("API ERROR", error.message);
        if (error.response.message) {
            return error.response.message;
        } else if (error.request) {
            return { message: 'no respond recieved from the backend' }
        } else {
            return { message: error.message }
        }
    }
}

export const postEditContactGroup = async (formData) => {

    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };
    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/editgroups`, formData, {
            headers: {
                Authorization: authHeader,
                "Content-Type": "multipart/data-form",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })


        return response;
    } catch (error) {
        console.log("API ERROR", error.message);
        if (error.response.message) {
            return error.response.message;
        } else if (error.request) {
            return { message: 'no respond recieved from the backend' }
        } else {
            return { message: error.message }
        }
    }
}

export const postContactNonuser = async (formData) => {

    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };
    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/groups/add_nonuser`, formData, {
            headers: {
                Authorization: authHeader,
                "Content-Type": "multipart/data-form",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })


        return response;
    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.data) {
            return error.response.message;
        } else if (error.request) {
            return { message: 'no respond recieved from the backend' }
        } else {
            return { message: error.message }
        }
    }
}

export const getAgoraTokenAPIHelper = async (params) => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/agora/generate-token/rtc/${params.channelName}/publisher/uid/${params.uid}'`, {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        });
        return response.data;
    } catch (error) {
        console.log("API error", error);
        if (error.response.message) {
            return error.request.message;
        } else if (error.request) {
            return { message: 'server is not responding ' }
        } else {
            return { message: error.message }
        }
    }
}


export const sendGroupCallInvitaionHelper = async (params) => {

    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };
    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/agora/generate-token/request-call`, params, {
            headers: {
                Authorization: authHeader,
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })


        return response;
    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.data) {
            return error.response.message;
        } else if (error.request) {
            return { message: 'no respond recieved from the backend' }
        } else {
            return { message: error.message }
        }
    }
}


export const getConversationsAPIHelper = async () => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/socketio/conversationList`, {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        });
        return response.data;
    } catch (error) {
        console.log("API error", error);
        if (error.response.message) {
            return error.request.message;
        } else if (error.request) {
            return { message: 'server is not responding ' }
        } else {
            return { message: error.message }
        }
    }
}


export const getusersSearchResultsAPIHelper = async (params) => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/connection/search-get-user/`,
            {
                params: {
                    searchParam: params.searchParam,
                    limit: 20,
                    offset: params.offsetValue,
                },
                headers: {
                    "Content-Type": "application/json",
                }
            });
        return response.data;
    } catch (error) {
        console.log("API error", error);
        if (error.response.message) {
            return error.request.message;
        } else if (error.request) {
            return { message: 'server is not responding ' }
        } else {
            return { message: error.message }
        }
    }
}

export const getGroupMembersAPIHelper = async (params) => {
    try {
        const response = await API.get(
            `${process.env.REACT_APP_BACKEND_URL}/usercontact/groups/${params}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": process.env.REACT_APP_API_KEY,
                },
            }
        );

        const data = response?.data;

        if (data?.statusCode === 200) {
            const groupDetails = {
                group_id: data?.groupDetails?.group_id,
                group_name: data?.groupDetails?.group_name,
                group_subname: data?.groupDetails?.group_subname || "",
                group_type: data?.groupDetails?.group_type,
                group_category: data?.groupDetails?.group_category,
                group_desc: data?.groupDetails?.group_desc || "",
                group_image: data?.groupDetails?.group_image,
                created_at: data?.groupDetails?.created_at,
                user_ref_id: data?.groupDetails?.user_ref_id,
                is_editable: !!data?.groupDetails?.is_editable,
            };
            const members = data?.members?.map((member) => {
                const role =
                    member?.designation ||
                    member?.field_of_study ||
                    member?.title ||
                    "---";

                const subTitle =
                    member?.profession_department ||
                    member?.institute ||
                    member?.nickname ||
                    "---";

                return {
                    contact_ref_id: member?.user_ref_id,
                    img: member?.profile_url,
                    name: `${member?.first_name} ${member?.last_name}`.trim(),
                    role,
                    subTitle,
                    verified: !!member?.is_verified,
                    phone_no: member?.phone_no?.replace(/[\s-]/g, ""),
                    email: member?.email?.trim(),
                    contact_role: member?.role,
                };
            });
            return {
                success: true,
                groupDetails,
                members,
            };
        } else {
            return { success: false, groupDetails: null, members: [] };
        }
    } catch (error) {
        console.log("API error:", error);
        return {
            success: false,
            message: error.message,
            groupDetails: null,
            members: [],
        };
    }
};
